import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';

export const FdrThemeSearchControlWrapper = styled.div({
  backgroundColor: 'white',
});

export const FdrThemeSearchControlToggler = styled.div(
  ({ theme: { FONT_SIZE, colors } }) =>
    sx2CssThemeFn({
      textAlign: 'right',
      color: 'primary',
      borderBottom: '1px solid',
      borderBottomColor: 'borderColor',
      mx: 4,
      '.search-control-link': {
        ...FONT_SIZE.LINK_LARGE,
        my: 2,
        color: colors.defaultText,
        textDecoration: 'underline',
        textDecorationColor: colors.linkUnderlineColor,
        textUnderlineOffset: '6px',
        transition: 'none',
        '&:hover,&:focus': {
          color: colors.defaultText,
          textDecorationColor: colors.defaultText,
        },
      },
    })
);
